// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oecp-md-subset-form[data-v-1a819686]{background:#fff!important;height:100%}", ""]);
// Exports
module.exports = exports;
